module.exports = __webpack_public_path__ + "static/media/ilkley-7.0ff1ae64.jpg";